import React from "react";

import clsx from "clsx";
import { Link } from "react-router-dom";

import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { useDesignElementManager } from "@hooks/use-design-element-manager";
import { PLATFORM_NORTHBEAM } from "@north-beam/nb-common";
import { generateAnonBase64Hash } from "@utils/anonymous";
import { usePrefs } from "@utils/client-side-preferences";

import { type TableRowType } from "../performance-tracking-table";

export const DimensionDataFormatter = ({
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { user } = useUser();
  const row = _row as TableRowType;
  const { designElementManager } = useDesignElementManager();

  const isAnon = usePrefs().isDemoMode;
  const naming = generateAnonBase64Hash({
    value: row.metadata.currentBreakdown.value,
    doAnon: isAnon,
    prefix: "channel",
  });

  const shouldDrawIcons =
    row.metadata.currentBreakdown.key === PLATFORM_NORTHBEAM;

  const iconKey = row.metadata.breakdowns[PLATFORM_NORTHBEAM] ?? "";
  const icon = designElementManager.getDesignElement(iconKey).getComponent({
    size: "20px",
  });

  return (
    <div className="flex flex-col justify-center h-full relative name-table-cell">
      <div className="flex items-center space-x-2 font-semibold font-sans truncate">
        {shouldDrawIcons && icon}
        <div className={clsx("truncate")}>
          <div
            className={clsx(
              "font-sans text-[0.5rem] text-gray+2 leading-3 uppercase truncate",
              {
                "mb-1": true,
              },
            )}
          >
            {row.metadata.currentBreakdown.key}
          </div>
          <Link
            to={user.pathFromRoot("sales")}
            className="text-cosmic no-underline hover:text-cosmic+1"
          >
            {naming}
          </Link>
        </div>
      </div>
    </div>
  );
};
